import { gql } from "@apollo/client";

export const VCS_PROVIDERS_IN_SPACE = gql`
  query VcsProvidersInSpace($spaceId: ID!) {
    providersInSpace(id: $spaceId)
  }
`;
